'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactIntl = require('react-intl');

var _topNav = require('../../../top-nav');

var _mobileSearchMenu = require('../../../mobile-search-menu');

var _reviewModal = require('../../../review-modal');

var _signUpModal = require('../../../sign-up-modal');

var _doctifyModals = require('../../../doctify-modals');

var _dropdowns = require('../transformers/dropdowns');

var _reduxSimpleAuth = require('redux-simple-auth');

var _doctifyUtils = require('doctify-utils');

var _loaders = require('../utils/loaders');

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _searchPage = require('../../../search-page');

var _constants = require('../../../../src/client/utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global document */

var globalComponentsLoader = new _doctifyUtils.PageLoader(_loaders.loaders);

var globalActions = _doctifyGlobalRedux2.default.globalActions;
var TopNavActions = globalActions.TopNavActions;
var CookieModalActions = globalActions.CookieModalActions;
var ReviewModalActions = globalActions.ReviewModalActions;
var SignUpModalActions = globalActions.SignUpModalActions;
var AutocompleteActions = globalActions.AutocompleteActions;
var MobileSearchMenuActions = globalActions.MobileSearchMenuActions;
var SearchTermsActions = globalActions.SearchTermsActions;
var ExpiredSessionModalActions = globalActions.ExpiredSessionModalActions;
var AppActions = globalActions.AppActions;
var topNavTransformers = _doctifyGlobalRedux2.default.globalTransformers.topNav;

var locale = 'en'; // eslint-disable-line

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0]; // eslint-disable-line


var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var MIN_TOP_DISTANCE = 500;
var SCROLL_THROTTLE_DURATION = 700;

var scrollTopButton = void 0;
var shouldReassignScrollTopButton = void 0;

var detectScroll = (0, _throttle3.default)(function () {
	if (typeof window === 'undefined') return;
	var y = window.scrollY;
	if (scrollTopButton && scrollTopButton.style.display === 'none') {
		shouldReassignScrollTopButton = true;
	}
	if (y > MIN_TOP_DISTANCE && (!scrollTopButton || shouldReassignScrollTopButton) && document.getElementsByClassName(_style2.default.backToTopButton).length) {
		scrollTopButton = document.getElementsByClassName(_style2.default.backToTopButton)[0];
		shouldReassignScrollTopButton = false;
		scrollTopButton.style.display = 'block';
	} else if (y > MIN_TOP_DISTANCE && scrollTopButton) {
		scrollTopButton.style.display = 'block';
	} else if (scrollTopButton) {
		scrollTopButton.style.display = 'none';
	}
}, SCROLL_THROTTLE_DURATION);

var GlobalComponents = function GlobalComponents(props) {

	var buildMobileSearchQueryString = function buildMobileSearchQueryString() {
		var url = '/search?';

		var selectedKeyword = props.mobileSearchMenu.selectedKeyword;

		/*
   * Need to account for when there is no search text defined and remove the text parameter from the URL.
   */
		var searchKeyword = encodeURIComponent(!selectedKeyword ? 'text' : selectedKeyword.keyword_type || selectedKeyword.type || props.mobileSearchMenu.selectedMenuItem === 'healthcheck' && 'healthCheck' || props.mobileSearchMenu.selectedMenuItem === 'scan' && 'scan') + '=' + encodeURIComponent(!selectedKeyword ? props.searchTerms.searchText : selectedKeyword.name) + '&';

		if (props.searchTerms && props.searchTerms.searchText && props.searchTerms.searchText.length || props.mobileSearchMenu && selectedKeyword && selectedKeyword.name && selectedKeyword.name.length) {
			url += searchKeyword;
		}

		url += props.mobileSearchMenu.selectedInsurer ? 'insurer=' + encodeURIComponent(props.mobileSearchMenu.selectedInsurer.name) + '&' : '';

		url += 'sort=relevance&';
		url += 'page=1&';

		url += props.mobileSearchMenu.selectedLocation && !props.autocomplete.location_search_center ? 'location=' + encodeURIComponent(props.mobileSearchMenu.selectedLocation.name) + '&' : '';

		url += !props.mobileSearchMenu.selectedLocation && props.autocomplete.location_search_center ? 'search_center=' + encodeURIComponent(props.autocomplete.location_search_center.latitude) + ',' + encodeURIComponent(props.autocomplete.location_search_center.longitude) + '&' : '';

		url += 'search_radius=' + _searchPage.constants.DEFAULT_WITHIN + '&types_filter=' + (props.mobileSearchMenu.selectedMenuItem === 'keyword' ? '11' : '01') + '&';

		var network = selectedKeyword && selectedKeyword.networks && selectedKeyword.networks[0];
		if (network) {
			url += 'network=' + network + '&';
		}

		url += 'search_type=' + encodeURIComponent(props.mobileSearchMenu.selectedMenuItem === 'keyword' ? 'appointment' : props.mobileSearchMenu.selectedMenuItem) + 's';

		return url;
	};

	if (typeof window !== 'undefined') {
		window.addEventListener('scroll', detectScroll);
	}

	(0, _doctifyUtils.execClientSideOnly)(props.init, [props]);
	if (props.location && props.location.query && props.location.query.logout && props.isAuthenticated) {
		props.sessionActions.invalidateSession();
	}

	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			'div',
			{ className: _style2.default.GlobalComponents },
			typeof window !== 'undefined' && props.location.pathname !== '/' && _react2.default.createElement(
				'div',
				{ className: _style2.default.backToTopButton,
					onClick: function onClick() {
						(0, _doctifyUtils.scrollToTop)('scroll');
					} },
				_react2.default.createElement(
					'div',
					{ className: _style2.default.arrowContainer },
					_react2.default.createElement('i', { className: 'ion-chevron-up' })
				)
			),
			_react2.default.createElement(_topNav.TopNav, (0, _extends3.default)({
				currentProfile: props.isAuthenticated && topNavTransformers.profileTransformer(props.session.selectedProfile) || undefined,
				availableProfiles: props.isAuthenticated && topNavTransformers.profilesTransformer((0, _doctifyUtils.deconstructProfiles)(props.session.profiles)) || undefined,
				loggedIn: props.isAuthenticated,
				logOut: function logOut() {
					props.topNavActions.invalidateToken(props.session.auth_token).then(function () {
						return props.sessionActions.invalidateSession();
					});
				}
			}, props.topNav, props.topNavActions, {
				onProfileClicked: _doctifyUtils.updateSelectedProfile,
				openReviewModal: props.reviewModalActions.openReviewModal,
				openSignUpModal: props.signUpModalActions.openSignUpModal,
				openMobileSearchMenu: props.mobileSearchMenuActions.openMobileSearchMenu,
				boxShadowOnSearchPage: props.location && props.location.pathname && props.location.pathname.includes('search'),
				enableScrollToTop: props.enableScrollToTop,
				onHeaderResize: props.appActions.updateHeaderSize,
				app: props.app
			})),
			_react2.default.createElement(_mobileSearchMenu.MobileSearchMenu, (0, _extends3.default)({}, props.mobileSearchMenu, props.mobileSearchMenuActions, {

				keywords: props.mobileSearchMenu.selectedMenuItem === 'keyword' && (props.searchTerms.searchText && (0, _dropdowns.sortMobileResults)(props.autocomplete.directory) || (0, _dropdowns.transformDropdownSpecialties)(props.listings.specialties, _constants.requiredTopLevelSpecialtiesNames)) || props.mobileSearchMenu.selectedMenuItem === 'healthcheck' && (props.autocomplete.healthChecks.length && props.autocomplete.healthChecks || (0, _dropdowns.transformDropdownTreatmentGroups)(props.listings.healthChecksTreatmentGroups)) || props.mobileSearchMenu.selectedMenuItem === 'scan' && (props.autocomplete.scans.length && props.autocomplete.scans || (0, _dropdowns.transformDropdownTreatmentGroups)(props.listings.scansTreatmentGroups)),

				locations: props.autocomplete.location,
				insurers: (0, _dropdowns.transformDropdownInsurer)(props.listings.insurers),

				clearLocation: props.autocompleteActions.clearLocationAutocomplete,
				keywordFilterChange: props.mobileSearchMenu.selectedMenuItem === 'keyword' && props.getMobileKeywordAutocomplete || props.mobileSearchMenu.selectedMenuItem === 'healthcheck' && props.getMobileHealthCheckAutocomplete || props.mobileSearchMenu.selectedMenuItem === 'scan' && props.getMobileScanAutocomplete,

				locationFilterChange: props.getMobileLocationAutocomplete,

				getLocationNearMe: props.getLocationNearMe,
				clearLocationNearMe: props.clearLocationNearMe,
				usingNearMe: props.autocomplete.usingNearMe,
				findingLocation: props.autocomplete.findingLocation,

				goToProfile: function goToProfile(option) {
					if (option.type && option.type === 'specialist') {
						_reactRouter.browserHistory.push('/specialist/' + option.uri_id);
					} else if (option.type && option.type === 'practice') {
						_reactRouter.browserHistory.push('/practice/' + option.uri_id);
					}
				},
				doSearch: function doSearch() {
					var queryString = buildMobileSearchQueryString();
					props.searchTermsActions.searchTextChanged();
					_reactRouter.browserHistory.push(queryString);
				}
			})),
			props.expiredSessionModal.isOpen && _react2.default.createElement(_doctifyModals.ExpiredSessionModal, {
				closeModal: function closeModal() {
					props.sessionActions.invalidateSession();
					props.expiredSessionModalActions.close();
					_reactRouter.browserHistory.push('/login');
				}
			}),
			props.reviewModal.isOpen && _react2.default.createElement(_reviewModal.ReviewModal, (0, _extends3.default)({}, props.reviewModal, props.reviewModalActions)),
			props.signUpModal.isOpen && _react2.default.createElement(_signUpModal.SignUpModal, (0, _extends3.default)({}, props.signUpModal, props.signUpModalActions, {
				specialties: props.listings.topLevelSpecialties
			})),
			!props.mobileSearchMenu.open && props.children
		)
	);
};

GlobalComponents.propTypes = {
	isAuthenticated: require('react').PropTypes.any.isRequired,
	session: require('react').PropTypes.object.isRequired,
	autocomplete: require('react').PropTypes.object.isRequired,
	searchTerms: require('react').PropTypes.object.isRequired,
	listings: require('react').PropTypes.object.isRequired,
	topNav: require('react').PropTypes.object.isRequired,
	mobileSearchMenu: require('react').PropTypes.object.isRequired,
	reviewModal: require('react').PropTypes.object.isRequired,
	cookieModal: require('react').PropTypes.object.isRequired,
	signUpModal: require('react').PropTypes.object.isRequired,
	expiredSessionModal: require('react').PropTypes.object.isRequired,
	sessionActions: require('react').PropTypes.object.isRequired,
	autocompleteActions: require('react').PropTypes.object.isRequired,
	topNavActions: require('react').PropTypes.object.isRequired,
	mobileSearchMenuActions: require('react').PropTypes.object.isRequired,
	reviewModalActions: require('react').PropTypes.object.isRequired,
	signUpModalActions: require('react').PropTypes.object.isRequired,
	expiredSessionModalActions: require('react').PropTypes.object.isRequired,
	searchTermsActions: require('react').PropTypes.object.isRequired,
	appActions: require('react').PropTypes.object.isRequired,
	children: require('react').PropTypes.any,
	location: require('react').PropTypes.object.isRequired,
	invalidateSession: require('react').PropTypes.func.isRequired,
	getMobileKeywordAutocomplete: require('react').PropTypes.func.isRequired,
	getMobileHealthCheckAutocomplete: require('react').PropTypes.func.isRequired,
	getMobileScanAutocomplete: require('react').PropTypes.func.isRequired,
	getMobileLocationAutocomplete: require('react').PropTypes.func.isRequired,
	getLocationNearMe: require('react').PropTypes.func.isRequired,
	clearLocationNearMe: require('react').PropTypes.func.isRequired,
	init: require('react').PropTypes.func.isRequired,
	enableScrollToTop: require('react').PropTypes.func.isRequired
};
GlobalComponents.displayName = 'GlobalComponents';

GlobalComponents.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
	return {
		global: state.global,
		topNav: state.global.topNav,
		cookieModal: state.global.cookieModal,
		reviewModal: state.global.reviewModal,
		signUpModal: state.global.signUpModal,
		searchTerms: state.global.searchTerms,
		autocomplete: state.global.autocomplete,
		listings: state.global.listings,
		expiredSessionModal: state.global.expiredSessionModal,
		mobileSearchMenu: state.global.mobileSearchMenu,
		session: (0, _reduxSimpleAuth.getSessionData)(state),
		isAuthenticated: (0, _reduxSimpleAuth.getIsAuthenticated)(state),
		app: state.global.app
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		cookieModalActions: (0, _redux.bindActionCreators)(CookieModalActions, dispatch),
		topNavActions: (0, _redux.bindActionCreators)(TopNavActions, dispatch),
		reviewModalActions: (0, _redux.bindActionCreators)(ReviewModalActions, dispatch),
		searchTermsActions: (0, _redux.bindActionCreators)(SearchTermsActions, dispatch),
		signUpModalActions: (0, _redux.bindActionCreators)(SignUpModalActions, dispatch),
		expiredSessionModalActions: (0, _redux.bindActionCreators)(ExpiredSessionModalActions, dispatch),
		sessionActions: (0, _redux.bindActionCreators)({ invalidateSession: _reduxSimpleAuth.invalidateSession }, dispatch),
		autocompleteActions: (0, _redux.bindActionCreators)(AutocompleteActions, dispatch),
		mobileSearchMenuActions: (0, _redux.bindActionCreators)(MobileSearchMenuActions, dispatch),
		appActions: (0, _redux.bindActionCreators)(AppActions, dispatch),
		invalidateSession: function (_invalidateSession) {
			function invalidateSession() {
				return _invalidateSession.apply(this, arguments);
			}

			invalidateSession.toString = function () {
				return _invalidateSession.toString();
			};

			return invalidateSession;
		}(function () {
			dispatch((0, _reduxSimpleAuth.invalidateSession)());
		}),
		getMobileKeywordAutocomplete: function getMobileKeywordAutocomplete(filter) {
			dispatch(SearchTermsActions.searchTextChanged(filter));
			if (filter.trim().length > 1) {
				(0, _doctifyUtils.googleWrapper)(function () {
					dispatch(AutocompleteActions.getDirectoryAutocomplete(filter));
				});
			} else {
				dispatch(AutocompleteActions.clearDirectoryAutocomplete());
			}
		},
		getMobileHealthCheckAutocomplete: function getMobileHealthCheckAutocomplete(filter) {
			dispatch(SearchTermsActions.searchTextChanged(filter));
			if (filter.trim().length > 1) {
				(0, _doctifyUtils.googleWrapper)(function () {
					dispatch(AutocompleteActions.getHealthChecksAutocomplete(filter));
				});
			} else {
				dispatch(AutocompleteActions.clearHealthChecksAutocomplete());
			}
		},
		getMobileScanAutocomplete: function getMobileScanAutocomplete(filter) {
			dispatch(SearchTermsActions.searchTextChanged(filter));
			if (filter.trim().length > 1) {
				(0, _doctifyUtils.googleWrapper)(function () {
					dispatch(AutocompleteActions.getScansAutocomplete(filter));
				});
			} else {
				dispatch(AutocompleteActions.clearScansAutocomplete());
			}
		},
		getMobileLocationAutocomplete: function getMobileLocationAutocomplete(filter) {
			if (filter.trim().length > 1) {
				(0, _doctifyUtils.googleWrapper)(function () {
					dispatch(AutocompleteActions.getLocationAutocomplete(filter));
				});
			} else {
				dispatch(AutocompleteActions.clearLocationAutocomplete());
			}
		},
		getLocationNearMe: function getLocationNearMe() {
			return new _promise2.default(function (resolve, reject) {
				dispatch(AutocompleteActions.getLocationNearMe()).then(function () {
					resolve();
				}).catch(function () {
					reject();
				});
			});
		},
		clearLocationNearMe: function clearLocationNearMe() {
			dispatch(AutocompleteActions.clearLocationNearMe());
		},
		enableScrollToTop: function enableScrollToTop() {
			dispatch(AppActions.canScrollToTop(true));
		},

		init: function init(props) {
			globalComponentsLoader.runOnce(dispatch, props).then(function (isFirstLoad) {
				var reviewCode = props.location && props.location.query && (props.location.query.reviewCode || props.location.query.review_code);
				if (isFirstLoad && reviewCode && !props.reviewModal.isOpen) {
					dispatch(ReviewModalActions.validateCode(reviewCode)).then(function () {
						dispatch(ReviewModalActions.openReviewModal());
					});
				}
			});
		}
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GlobalComponents);


// WEBPACK FOOTER //
// ./components/global-components/lib/components/global-components.js